import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=274dd80f&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=274dd80f&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274dd80f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('274dd80f')) {
      api.createRecord('274dd80f', component.options)
    } else {
      api.reload('274dd80f', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=274dd80f&scoped=true&", function () {
      api.rerender('274dd80f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/paySettlement/detail.vue"
export default component.exports